// Portal-02 and portal-04 parks that have site_id in the captive portal redirect — To-Be flow
export const PILOT_SITE_IDS = new Set([
    // portal-01
    'ddx34mtp', 'dr4gji7j', '1z10s3mz', 'r0ep5x2k', 'pmfaai2m', '2n8q3738', 'i2admigs', 'k5djdtyo', '9a5d6gbw', '901gmym7', 'hkn67j5x', 'llwjxv99', 'wpaxo3vo',
    // portal-02
    'bz9000pw', 'xv1ah798', '03ib95ix', '5l8d8o1v', '6mgjo7tw', 'uxcxj870', 'fr0k308n', 'ycityxzo', 'g0oq4i8w', 'meaa5p4h', '1in4p6fv', 'xb0kfzxt', 'pqy7gikx',
    // portal-03
    'l9ko30gs', 'xktkjhgc', 'yktf083o', 'pt2fgdzo', 'bi7m5lwu', 'fobpu81w', '7ravymqo', 'o903k800', 'ja85j05m', '1uezxnpt', 'k1v976kn', '0ihnb3lk',
    // portal-04
    'lr1r7mkc', '7h2e6kxi', 'zw1j0vuw', 'h34wt7oo', '6ate93vn', '4297vzxr', '7akd9tti', 'yt1jxlno', '5w5eetui', 'f8167tuc', '6tldxk1k', 'u17fsmsa', 'zyi88h9o', 'hpxtdxli',
])

export const SITE_ID_TO_PARK = {
    // portal-01
    'ddx34mtp': { name: 'Broadland Sands',      parkCode: 'BS' },
    'dr4gji7j': { name: 'Birchington Vale',      parkCode: 'BV' },
    '1z10s3mz': { name: 'Dawlish Sands',         parkCode: 'DL' },
    'r0ep5x2k': { name: 'Landscove',             parkCode: 'LS' },
    'pmfaai2m': { name: 'Littondale',            parkCode: 'LT' },
    '2n8q3738': { name: 'Martello Beach',        parkCode: 'SO' },
    'i2admigs': { name: 'Par Sands',             parkCode: 'PS' },
    'k5djdtyo': { name: 'Rye Harbour',           parkCode: 'RH' },
    '9a5d6gbw': { name: 'St Osyth Beach',        parkCode: 'SO' },
    '901gmym7': { name: 'Stowford',              parkCode: 'ST' },
    'hkn67j5x': { name: 'Seawick',               parkCode: 'SW' },
    'llwjxv99': { name: 'West Mersea',           parkCode: 'WM' },
    'wpaxo3vo': { name: 'Waterside',             parkCode: 'WS' },
    // portal-02
    'bz9000pw': { name: 'Alberta',               parkCode: 'AB' },
    'xv1ah798': { name: 'Ashbourne Heights',     parkCode: 'AH' },
    '03ib95ix': { name: 'Coghurst Hall',         parkCode: 'CH' },
    '5l8d8o1v': { name: 'Felixstowe Beach',      parkCode: 'FS' },
    '6mgjo7tw': { name: 'Golden Sands',          parkCode: 'GS' },
    'uxcxj870': { name: 'Harts',                 parkCode: 'HT' },
    'fr0k308n': { name: 'Polperro',              parkCode: 'PL' },
    'ycityxzo': { name: 'Riviera Bay',           parkCode: 'RB' },
    'g0oq4i8w': { name: 'Sand le Mere',          parkCode: 'SM' },
    'meaa5p4h': { name: 'Sandhills',             parkCode: 'SH' },
    '1in4p6fv': { name: 'Solent Breezes',        parkCode: 'SL' },
    'xb0kfzxt': { name: 'Seaview',               parkCode: 'SV' },
    'pqy7gikx': { name: 'Tarka',                 parkCode: 'TK' },
    // portal-03
    'l9ko30gs': { name: 'Beauport',              parkCode: 'BP' },
    'xktkjhgc': { name: 'Brynteg',               parkCode: 'BT' },
    'yktf083o': { name: 'Carlton Meres',          parkCode: 'CM' },
    'pt2fgdzo': { name: 'Dovercourt',             parkCode: 'DC' },
    'bi7m5lwu': { name: 'Marlie',                parkCode: 'MF' },
    'fobpu81w': { name: 'Malvern View',           parkCode: 'MV' },
    '7ravymqo': { name: 'New Beach',              parkCode: 'NB' },
    'o903k800': { name: 'New Haven',              parkCode: 'NH' },
    'ja85j05m': { name: 'Pakefield',              parkCode: 'PF' },
    '1uezxnpt': { name: 'Suffolk Sands',          parkCode: 'SF' },
    'k1v976kn': { name: 'Turnberry',              parkCode: 'TB' },
    '0ihnb3lk': { name: 'Winchelsea Sands',      parkCode: 'WC' },
    // portal-04
    'lr1r7mkc': { name: 'Bodmin',                parkCode: 'BM' },
    '7h2e6kxi': { name: 'Bowland Fell',           parkCode: 'BF' },
    // Burghead, Lossiemouth and Silver Sands share site ID zw1j0vuw — Burghead used as primary
    // 'zw1j0vuw': { name: 'Lossiemouth',  parkCode: 'LM' },
    // 'zw1j0vuw': { name: 'Silver Sands', parkCode: 'SS' },
    'zw1j0vuw': { name: 'Burghead',               parkCode: 'BH' },
    'h34wt7oo': { name: 'Glendale',               parkCode: 'GD' },
    '6ate93vn': { name: 'Hengar Manor',           parkCode: 'HM' },
    '4297vzxr': { name: 'Hedley Wood',            parkCode: 'HW' },
    '7akd9tti': { name: 'Chichester Lakeside',    parkCode: 'LS' },
    'yt1jxlno': { name: 'Pevensey Bay',           parkCode: 'PB' },
    '5w5eetui': { name: 'Pentire',                parkCode: 'PH' },
    'f8167tuc': { name: 'Ribble Valley',          parkCode: 'RV' },
    '6tldxk1k': { name: 'Steeple Bay',            parkCode: 'SP' },
    'u17fsmsa': { name: 'Trevella',               parkCode: 'TV' },
    'zyi88h9o': { name: 'Wood Farm',              parkCode: 'WF' },
    'hpxtdxli': { name: 'Kingfisher',             parkCode: 'KF' },
}
